var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        { staticClass: "store-based-marketing-title" },
        [_c("CustomBreadcrumb")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shopVidi-campaigns" }, [
        _c("p", [_vm._v("ShopVidi EDM/SMS Campaigns")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Schedule and send messages to a segment of customers.")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "btn", on: { click: _vm.create } }, [
          _vm._v("Create Campaigns")
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("EDM /SMS       ")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-list" },
        [
          _c(
            "el-table",
            {
              ref: "edmTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "campaignName", label: "Name", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "fontBond campaign-name-",
                            on: {
                              click: function($event) {
                                return _vm.clickDetail(
                                  scope.row,
                                  "openRate",
                                  true
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.campaignName || "-") +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Total Stores", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(
                        scope.row["marketingStoreTypeList"],
                        function(itm, i) {
                          return _c("p", { key: i }, [
                            _c("span", [_vm._v(_vm._s(itm.storeType))]),
                            _vm._v("\n                ("),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "format",
                                    rawName: "v-format",
                                    value: "#,##",
                                    expression: "'#,##'"
                                  }
                                ],
                                staticStyle: { color: "#FB541C" }
                              },
                              [_vm._v(_vm._s(itm.count))]
                            ),
                            _vm._v(")\n            ")
                          ])
                        }
                      )
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "marketingCycle",
                  label: "Marketing Cycle",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("p", [
                          _vm._v(" " + _vm._s(scope.row.marketingCycle) + " ")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(scope.row.cycleStartTime) +
                              "-" +
                              _vm._s(scope.row.cycleEndTime)
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "Status", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#41B76A",
                              "font-weight": "500"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.status === 0
                                  ? "Not Effective"
                                  : "Effective"
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "marketingBatch",
                  label: "Marketing Batch",
                  width: "110"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.marketingBatch
                          ? _c("div", { staticClass: "batch-field" }, [
                              _vm._v(_vm._s(scope.row.marketingBatch))
                            ])
                          : _c("div", [_vm._v("-")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sendTime", label: "Send time", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.sendTime
                          ? [_vm._v(_vm._s(scope.row.sendTime))]
                          : [_vm._v("-")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "marketingType",
                  label: "Maketing Type",
                  width: "180"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("filterMaketingType")(
                                scope.row["marketingType"]
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryRate",
                  label: "Delivery rate",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["deliveryRecipients"] &&
                        scope.row["deliveryRecipients"] > 0
                          ? [
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "0.00%",
                                      expression: "'0.00%'"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(scope.row["deliveryRate"]))]
                              ),
                              _vm._v(" "),
                              _c("p", { staticStyle: { color: "#2866FF" } }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "format",
                                        rawName: "v-format",
                                        value: "#,##",
                                        expression: "'#,##'"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row["deliveryRecipients"])
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Total recipients")])
                              ])
                            ]
                          : [_vm._v("\n            -\n          ")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "openRate", label: "Open rate", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["openRecipients"] &&
                        scope.row["openRecipients"] > 0
                          ? [
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "0.00%",
                                      expression: "'0.00%'"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(scope.row["openRate"]))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#2866FF",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickDetail(
                                        scope.row,
                                        "openRate"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "format",
                                          rawName: "v-format",
                                          value: "#,##",
                                          expression: "'#,##'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row["openRecipients"])
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("recipients")])
                                ]
                              )
                            ]
                          : [_vm._v("\n            -\n          ")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "clickRate", label: "Click rate", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["clickRecipients"] &&
                        scope.row["clickRecipients"] > 0
                          ? [
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "0.00%",
                                      expression: "'0.00%'"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(scope.row["clickRate"]))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#2866FF",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickDetail(
                                        scope.row,
                                        "clickRate"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "format",
                                          rawName: "v-format",
                                          value: "#,##",
                                          expression: "'#,##'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row["clickRecipients"])
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("recipients")])
                                ]
                              )
                            ]
                          : [_vm._v("-")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "viewedProduct",
                  label: "Viewed Product",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["viewProductAmount"] &&
                        scope.row["viewProductAmount"] > 0
                          ? [
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "$#,##.##",
                                      expression: "'$#,##.##'"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(scope.row["viewProductAmount"]))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#2866FF",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickDetail(
                                        scope.row,
                                        "viewProduct"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "format",
                                          rawName: "v-format",
                                          value: "#,##",
                                          expression: "'#,##'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row["viewProductRecipients"]
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("recipients")])
                                ]
                              )
                            ]
                          : [_vm._v("\n            -\n          ")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "addToCartAmount",
                  label: "Added to Cart",
                  width: "110"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["addToCartAmount"] &&
                        scope.row["addToCartAmount"] > 0
                          ? [
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "$#,##.##",
                                      expression: "'$#,##.##'"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(scope.row["addToCartAmount"]))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#2866FF",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickDetail(
                                        scope.row,
                                        "addToCart"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "format",
                                          rawName: "v-format",
                                          value: "#,##",
                                          expression: "'#,##'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row["addToCartRecipients"])
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("recipients")])
                                ]
                              )
                            ]
                          : [_vm._v("-")]
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Operate", width: "90" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row["showOperation"]
                          ? [
                              _c(
                                "span",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickDetail(
                                        scope.row,
                                        "openRate"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Views")]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.query.pageNo,
          total: _vm.total,
          pageSize: _vm.query.pageSize
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-area" }, [
      _c("div", [
        _c("img", {
          attrs: { src: require("@/assets/img/marketing/boost-your-sales.png") }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Boost your sales")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/assets/img/marketing/use-alto-create-copy.png")
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Use Alto create copy")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/assets/img/marketing/create-seasonal-promotion.png")
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Create a seasonal promotion")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484d4c04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484d4c04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store-based-marketing/store-based-marketing-list.vue
// module id = rLPC
// module chunks = 2